import { messageStyles } from "@insite/content-library/Widgets/ContactUs/Message";
import { css } from "styled-components";

messageStyles.messageTextArea = {
    css: css`
        resize: none;
    `,
};
